import type { FC, ReactNode } from 'react'

import { MessageCircle } from 'lucide-react'
import { cn } from '@/lib/utils'
import { contact, isWhatsAppEnabled } from '@/constants/content'

interface WhatsAppLinkProps {
    className?: string
    variant?: 'button' | 'text'
}

// The only place the WhatsApp destination is rendered. It reads the single setting in constants/content.ts
// and renders nothing when that channel is switched off.
export const WhatsAppLink: FC<WhatsAppLinkProps> = ({
    className,
    variant = 'button'
}): ReactNode => {
    if (!isWhatsAppEnabled()) return null

    return (
        <a
            href={contact.whatsapp.url}
            target='_blank'
            rel='noopener noreferrer'
            aria-label={`${contact.whatsapp.label} on WhatsApp (opens in a new tab)`}
            className={cn(
                variant === 'button'
                    ? 'inline-flex min-h-12 items-center justify-center gap-2 rounded-xl bg-orange px-6 font-semibold text-navy transition hover:bg-orange-light active:scale-[0.98]'
                    : 'inline-flex items-center gap-2 text-cool-grey-light transition hover:text-soft-white',
                className
            )}
        >
            <MessageCircle className='size-5' aria-hidden />
            {contact.whatsapp.label}
        </a>
    )
}
